import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";

export default function ARTICLE_2022_07_26_CHECKLISTS(props) {

	return (
		<div className='content'>

			<h1><FontAwesomeIcon icon={faListCheck}/> Basic Checklists</h1>

			<p>
				In radio control aviation, just like in standard aviation, checklists
				are a good way to remember the details of the various activities
				involved in flying. Here are a few basic checklists to help you get
				started on your own personal checklists to fly safely.
			</p>

			<h2>Heading to the Field</h2>
			<div>
				<ul>
					<li>Aircraft</li>
					<li>Battery</li>
					<li>Radio (Transmitter)</li>
				</ul>
			</div>

			<h2>Pre-Flight</h2>
			<div>
				<ul>
					<li>Turn on transmitter and check battery level</li>
					<li>Connect aircraft battery and secure</li>
					<li>Secure aircraft openings</li>
					<li>Aircraft control surface High-5 check</li>
				</ul>
			</div>

			<h2>Post-Flight</h2>
			<div>
				<ul>
					<li>Disconnect aircraft battery</li>
					<li>Turn off transmitter</li>
				</ul>
			</div>

		</div>
	)

}
